import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'
import { i18n } from '@/i18n'

export default [
  {
    name: 'residential-edit',
    path: '/residentials/:id/edit/:step?',
    props: true,
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "residential-mutate" */ '@/views/Residential/Mutate/Component.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'residential-contracts',
    props: true,
    path: '/residentials/:id/contracts',
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "contracts" */ '@/views/Contract/Contracts/Component.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'residential-bid-create',
    props: true,
    path: '/residentials/:id/bid/create',
    component: () => LazyLoadView(import(/* webpackChunkName: "bid-create" */ '@/views/Contract/Bid/Create.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'residential-purchase-mutate',
    props: true,
    path: '/residentials/:id/purchase/mutate',
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "purchase-mutate" */ '@/views/Contract/Purchase/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'residential-complaints',
    path: '/residentials/:id/complaints',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "tasks" */ '@/views/Task/Tasks.vue')),
    meta: {
      context: 'unit',
      title: i18n.tc('complaint', 2),
      type: 'complaint',
      defaultFilter: ctx => ({
        search: '',
        type: 'complaint',
        status: ['request', 'undone'],
        references: [
          {
            onModel: `Residential`,
            ref: ctx.$route.params.id,
            inherit: true,
          },
        ],
      }),

      breadcrumb: ctx => ({ onModel: 'Residential', ref: ctx.$route.params.id }),
    },
    beforeEnter: isAuthenticated,
  },
]
